import { Modal } from "antd";
import DocumentInfoContent from "./DocumentInfoContent";

const DocumentInfoModal = (props: any) => {
  return (
    <Modal
      centered
      zIndex={10000}
      footer={[]}
      onCancel={props.close}
      open={props.openState}
    >
      <DocumentInfoContent close={props.close} />
    </Modal>
  );
};

export default DocumentInfoModal;
